























	import { Component, Vue, Prop } from 'vue-property-decorator';
    import { TranslateResult } from 'vue-i18n';
    import { Action } from 'vuex-class';
    import axios from 'axios';
    import { api } from '@/api';

    @Component
    export default class LocalePicker extends Vue
    {

        public localeUpdating: boolean = false;

        public locales: any[] = [
			{
				code: 'en',
			},
			{
				code: 'sr',
			},
        ];
        
        @Action('locale/saveLocale') saveLocale: any;
        @Action('languages/refreshLanguages') refreshLanguages: any;

		public async changeLocale(locale: string): Promise<void> {

            this.localeUpdating = true;

            this.saveLocale(locale);

            await axios.post(api.path('v1.profile.locale'), { locale: locale });
            
            // after successful change we need to reload translatable api data
            await this.refreshLanguages();

            this.localeUpdating = false;
		}
    }

